import { defineMessages, FormattedMessage } from 'react-intl';

import { confirmationToast, failureToast } from '../components/Toast';

export const clipboardMessages = defineMessages({
  copiedSuccess: { defaultMessage: 'Copié dans le presse-papiers', id: 'cYkY7e' },
  copiedFailure: { defaultMessage: 'Une erreur est survenue lors de la copie', id: 'Z7IPJH' },
  noTextToCopy: { defaultMessage: 'Aucun texte à copier', id: 'gdwMdj' },
});

export const copyToClipboard = (text: string | undefined) =>
  text
    ? navigator.clipboard
        .writeText(text)
        .then(() =>
          confirmationToast(<FormattedMessage {...clipboardMessages.copiedSuccess} />, {
            toastId: 'copySuccess',
          }),
        )
        .catch(() =>
          failureToast(<FormattedMessage {...clipboardMessages.copiedFailure} />, {
            toastId: 'copyFailure',
          }),
        )
    : failureToast(<FormattedMessage {...clipboardMessages.noTextToCopy} />, { toastId: 'noText' });
